<template>
  <pt-export-history-table class="pt-export-history-table__withData" :tableLabels="tableLabels" @getTableData="getTableData" ref="table" :total-number="totalNumber" :page-size="pageSize" :tableData="tableData">
    <slot />
  </pt-export-history-table>
</template>

<script>
import PtExportHistoryTable from './index'
export default {
  name: 'pt-export-history-table__withData',
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    queryName: {
      type: String,
      default: ''
    },
    selectTab: {
      type: String,
      default: ''
    }
  },
  computed: {
    page () {
      return this.$refs.table && this.$refs.table.page
    },
    isDownload () {
      return this.$route.query.isDownload === 'true'
    },
    isImport () {
      return this.$route.query.isImport === 'true'
    },
    batchNumber () {
      return this.$route.query.batchNumber
    }
  },
  data () {
    return {
      totalNumber: 0,
      loading: false,
      tableData: [],
      intervalIndex: 0
    }
  },
  components: {
    'pt-export-history-table': PtExportHistoryTable
  },
  watch: {
    queryName: {
      handler (val) {
        this.getTableData(0)
      },
      deep: true
    },
    intervalIndex (val) {
      if (val >= 10) {
        clearInterval(this.historySetInterval)
      }
    }
  },
  methods: {
    // 获取导出的数据类型
    // getExportType () {
    //   switch (this.queryName) {
    //     case 'order':this.resourceConfig = 'mall_order_export'
    //       break
    //     default :this.resourceConfig = null
    //       break
    //   }
    // },
    getTableData (page, next) {
      this.intervalIndex++
      //   this.getExportType()
      let data = {
        example: {
          resourceConfig: this.queryName
        },
        pageable: {
          page: page,
          size: this.pageSize,
          sort: 'createdDate,desc'
        },
        isDownload: this.isDownload
      }
      let ajaxUrl = 'labExportHistoryList'
      if (this.queryName === 'import_record') {
        data = {
          pageableParam: {
            page: page,
            size: this.pageSize,
            sort: 'createdDate,desc'
          }
        }
        ajaxUrl = 'getSamplesjobRecordAll'
      }
      if (this.isImport) {
        data = {
          batchNumber: this.batchNumber,
          pageableParam: {
            page:page,
            size: this.pageSize,
            sort: 'createdDate,desc'
					},
					isImport:this.isImport
        }
        ajaxUrl = 'importHistoryOfBill'
      }
      if (!next) {
        this.loading = true
      }
      // 获取其他导出记录（除实验室订单）
      // let apiUrl = this.queryName === 'lab_export' || this.queryName === 'lab_order_export' ? 'labExportHistoryList' : 'exportHistoryList'
      this.$store.dispatch(ajaxUrl, data).then(res => {
        this.totalNumber = res.totalNumber
        this.tableData = res.data
        this.loading = false
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.loading = false
        this.$message(err || '获取导出历史失败')
      })
    },
    reload () {
      this.$refs.table.reload()
    }
  },
  created () {
    this.historySetInterval = setInterval(() => {
      this.getTableData(this.page, false)
    }, 3000)
  },
  destroyed () {
    clearInterval(this.historySetInterval)
  },
  beforeDestroy () {
    clearInterval(this.historySetInterval)
  }
}
</script>
